// Bind to all buttons with data-prototype-container attribute
document.querySelector('body').addEventListener('click', (e) => {
    const element = e.target.closest('[data-prototype-container]');

    if (!element || !('prototypeContainer' in element.dataset)) {
        return;
    }

    const selector = element.dataset.prototypeContainer;
    const container = document.querySelector(selector);

    if (!container) {
        throw new Error(`Target container by the selector of "${selector}" was not found.`);
    }

    const htmlElement = container.querySelector('[data-prototype]');

    if (!('index' in container.dataset)) {
        container.dataset.index = htmlElement.childElementCount;
    }

    if (!htmlElement) {
        throw new Error(`Target container by the selector of "${selector}" does not contain a prototype element.`);
    }

    let prototypeName = '__name__';
    if (htmlElement.dataset.prototypeName) {
        prototypeName = htmlElement.dataset.prototypeName;
    }

    const content = document.createElement('div');
    content.innerHTML = htmlElement.dataset.prototype.replace(new RegExp(prototypeName, 'g'), container.dataset.index);

    container.dataset.index++;
    htmlElement.appendChild(content.firstElementChild);

    document.dispatchEvent(new Event('dom_changed'));
});

document.querySelector('body').addEventListener('click', (e) => {
    const element = e.target.closest('[data-remove]');

    if (!element) {
        return;
    }

    document.querySelector(element.dataset.remove).remove();
});
